import _ from 'lodash';
import { v4 } from 'uuid';

/**
 * CONSTANTS
*/

const EXPRESSIONS = {
  IS: 'is',
  IS_NOT: 'is_not',
  SELECTED: 'is_selected',
  NOT_SELECTED: 'is_not_selected',
};

export const OPERATIONS = {
  IF: 'If',
  AND: 'And',
};

/**
 * UTILS
*/

/** remove all underscore ocurrences */
const formatText = (value) => value.replace(/_/g, ' ');

/** build expressions based on the question type */
export const buildExpressions = (type) => {
  // FIXME Improve this method
  if (type !== 'multiple_select') {
    const isKey = EXPRESSIONS.IS;
    const isntKey = EXPRESSIONS.IS_NOT;

    return [
      { key: isKey, value: isKey, text: isKey },
      { key: isntKey, value: isntKey, text: formatText(isntKey) },
    ];
  }

  const isSelectedKey = EXPRESSIONS.SELECTED;
  const isntSelectedKey = EXPRESSIONS.NOT_SELECTED;

  return [
    { key: isSelectedKey, value: isSelectedKey, text: formatText(isSelectedKey) },
    { key: isntSelectedKey, value: isntSelectedKey, text: formatText(isntSelectedKey) },
  ];
};

export const isLabelEmpty = (label) => _.trim(label) === '';

// build a new default condition
export const buildConditionObject = () => ({
  id: v4(),
  surveyPageId: 'end_screen', // default is end_screen
  skipConditions: [
    {
      id: v4(),
      questionId: '',
      questionOptionId: '',
      operation: '',
    },
  ],
});
